module.exports = __webpack_public_path__ + "media/v2/components/shared/Image/status_games_icons/recent-34aa6d2968e495236af71a51e77e6d86.svg";